import { render, staticRenderFns } from "./ScreenGroupView.vue?vue&type=template&id=ac8fa7e6&scoped=true"
import script from "./ScreenGroupView.vue?vue&type=script&lang=js"
export * from "./ScreenGroupView.vue?vue&type=script&lang=js"
import style0 from "./ScreenGroupView.vue?vue&type=style&index=0&id=ac8fa7e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8fa7e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac8fa7e6')) {
      api.createRecord('ac8fa7e6', component.options)
    } else {
      api.reload('ac8fa7e6', component.options)
    }
    module.hot.accept("./ScreenGroupView.vue?vue&type=template&id=ac8fa7e6&scoped=true", function () {
      api.rerender('ac8fa7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/screen/ScreenGroupView.vue"
export default component.exports